import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Treino } from '../models/treino';

var httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class TreinoService {
  private url = 'api/treino';
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getToken(): string {
    var tokenJson = JSON.parse(localStorage.getItem('currentUser') || '');
    return tokenJson.token;
  }

  getById(id: number): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.get<any>(apiurl);
  }

  get(): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.get<any>(apiurl);
  }

  post(treino: Treino): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.post<Treino>(apiurl, treino, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  put(id: number, treino: Treino): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.put<Treino>(apiurl, treino, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }
  delete(id: number): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.delete<any>(apiurl, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }
}
